/**
 * Base class for all actions.
 */
class Action {
  type;
  config;
  log = [];
  meta = {};
  mode;
  #guid;

  constructor(config = {}, mode = "live") {
    this.config = config;
    this.mode = mode;
  }

  get guid() {
    return this.#guid;
  }

  set guid(value) {
    this.#guid = value;
  }

  execute(data) {
    throw new Error("Method 'execute()' must be implemented.");
  }

  undo(data) {
    throw new Error("Method 'undo()' must be implemented.");
  }

  explainAction() {
    throw new Error("Method 'explainAction()' must be implemented.");
  }

  explainUndo() {
    throw new Error("Method 'explainUndo()' must be implemented.");
  }

  hydrateMeta() {}

  addLog(result = true, message, icon = "", mode = "execute") {
    this.log.push({ time: Date.now(), type: this.type, result: icon != "" ? icon : result ? "✅" : "❌", message });
  }

  get logPrefix() {
    return `\x1b[30;41;1m[Action/${this.type}]`;
  }
}

export default Action;